module.exports = __webpack_public_path__ + "static/media/close-icon.9bb2c150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/chatbot/assets/close-icon.svg
// module id = 1005
// module chunks = 0